export const Types = {
    BED_DETAILS: "BED_DETAILS",
    BED_ID_ARRAY: "BED_ID_ARRAY",
    FAVORITE_BED_ID_ARRAY: "FAVORITE_BED_ID_ARRAY",
    HOSPITAL_DATA: "HOSPITAL_DATA",
    WARD_DATA: "WARD_DATA",
    PATIENT_DATA: "PATIENT_DATA",
    DEVICE_VITAL_DATA: "DEVICE_VITAL_DATA",
    ALARM_DATA: "ALARM_DATA",
    NOTIFICATION_DATA: "NOTIFICATION_DATA",
    CONFIG_VIEW_TYPE: "CONFIG_VIEW_TYPE",
    CONFIG_FILTER_TYPE: "CONFIG_FILTER_TYPE",
    CONFIG_MODAL: "CONFIG_MODAL",
    CONFIG_BED_DETAILS: "CONFIG_BED_DETAILS",
    CONFIG_ADD_COLUMN: "CONFIG_ADD_COLUMN",
    CONFIG_REMOVE_COLUMN: "CONFIG_REMOVE_COLUMN",
    CLEAR_ALARM: "CLEAR_ALARM",
    PATIENT_DISCHARGE: "PATIENT_DISCHARGE",
    CLEAR_STORE: "CLEAR_STORE",
    USER_ROLE: 'USER_ROLE',
    BED_DATA: 'BED_DATA',
    SIDEBAR_ACTIVE_ICON: 'SIDEBAR_ACTIVE_ICON',
    SELECTED_WARD: 'SELECTED_WARD',
    CHARTING_OPTION_NAVIGATION: "CHARTING_OPTION_NAVIGATION"
};